import { render } from "./Alliance.vue?vue&type=template&id=0af10f99&scoped=true"
import script from "./Alliance.vue?vue&type=script&lang=js"
export * from "./Alliance.vue?vue&type=script&lang=js"

import "./Alliance.vue?vue&type=style&index=0&id=0af10f99&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0af10f99"]])

export default __exports__